import { mapGetters } from 'vuex'
import { validateFileExt } from '@/utils/validate'
import { SongList } from '@/models/Complaint'
import BatchUploadDialog from '../BatchUploadDialog.vue'
import {
  rightFileExtType,
  TASK_TYPE_ENUM,
  LEVEL_ONE_APPEAL,
  mediaTypeMap,
  appealPlatMap,
} from '../../const'

export default {
  name: 'BasicAddTable',
  components: {
    BatchUploadDialog
  },
  props: {
    data: {
      type: Array,
      default: () => []
    },
    disabled: Boolean
  },
  data() {
    return {
      TASK_TYPE_ENUM,
      LEVEL_ONE_APPEAL,
      mediaTypeMap,
      appealPlatMap,
      rightFileExtType,

      showBatchUpload: false,
      showEdit: false,
      form: null
    }
  },
  computed: {
    ...mapGetters(['isExternalUser']),
    /**
     * @returns{String}
     */
    dialogTitle() {
      return this.form && +this.form.tracklistId ? `编辑（${this.form.tracklistId}）` : '新增单条录入'
    },
    /**
     * 表单校验项
     * 1. 内部用户不强制上传权利文件
     * @returns{Object}
     */
    rules() {
      const baseRules = {
        trackName: [{ required: true, message: '请输入歌曲/视频名称', trigger: 'blur' }],
        originTrackName: [{ required: true, message: '请输入歌曲/视频名称', trigger: 'blur' }],
      }
      const rightFileRule = {
        rightFileList: [{ required: true, type: 'array', message: '请上传权利文件', trigger: 'change' }],
      }

      return this.isExternalUser ? { ...baseRules, ...rightFileRule } : baseRules
    }
  },
  methods: {
    handleRightFileRemove(file, fileList) {
      this.form.rightFileList = fileList
    },
    handleRightFileError(err, file, fileList) {
      this.form.rightFileList = fileList
      this.$message.error('授权文件上传失败: ' + err.message)
    },
    handleRightFileSuccess(resp, file, fileList) {
      file.fileUrl = file.url = resp.data.url
      file.filePath = file.path = resp.data.file_id
      file.fileName = file.name
      file.md5 = resp.data.md5

      // 处理后台数据
      this.form.rightFileList = fileList.slice(-1)
      this.form.rightFile = {
        fileName: file.name,
        fileUrl: file.url,
        md5: file.md5
      }
    },
    handleRightFileBeforeUpload(file) {
      if (!validateFileExt(rightFileExtType, file.name)) {
        this.$message.warning('不支持的文件类型')
        return Promise.reject()
      }

      const sameFile = this.form.rightFileList.find(v => v.md5 === file.md5)
      if (sameFile) {
        this.$message.warning(`文件已存在，请检查【${file.name}】和【${sameFile.name}】`)
        return Promise.reject()
      }

      return Promise.resolve()
    },
    handleShowBatchUpload() {
      this.showBatchUpload = true
    },
    handleUpload(fileList, rightFileList) {
      const params = {
        url: fileList[0].url,
        mode: TASK_TYPE_ENUM.SONGLIST,
        complaintType: LEVEL_ONE_APPEAL.TORT.code,
        rightFileList
      }
      this.$emit('upload', params)
    },
    handleAdd() {
      this.form = new SongList()
      // 标识是新增歌单
      this.form.create = true
      this.showEdit = true
    },
    handleShowEdit(row) {
      this.form = new SongList(row)
      if (this.form.rightFile) {
        this.form.rightFileList = [{
          ...this.form.rightFile,
          name: this.form.rightFile.fileName,
          url: this.form.rightFile.fileUrl
        }]
      }
      this.showEdit = true
    },
    handleClose() {
      this.showEdit = false
      this.form = null
    },
    async handleSubmit() {
      try {
        await this.$refs.form.validate()
      } catch (error) {
        return
      }
      this.$emit('save', this.form)
      this.handleClose()
    },
    handleDel(row) {
      this.$alert(`确认删除歌单（${row.tracklistId}）`, '提示', {
        type: 'warning'
      }).then(_ => {
        row.isDel = 1
        this.$emit('save', row)
        this.handleClose()
      }).catch(_ => {})
    }
  }
}
